<template>
<section role="search" class="BuscadorStandalone-MAIN">
    <div class="INNER-MARGIN BuscadorStandalone-search">
        <input type="text" v-model.trim="searchTerm" @keyup.enter="searchCupones()" placeholder="Buscar"/>
        <button @click="searchCupones()"><img src="../assets/search.jpeg"/></button>
    </div>
</section>
</template>

<script>
export default {
    name: 'BuscadorStandalone',
    data(){
        return{
            searchTerm: '',
        }
    },
    methods:{
        getFrontURL(){
			return window.location.origin;
		},

        searchCupones(){
            const term = this.searchTerm;
            if(!term || term == "") return;
            window.location.href = this.getFrontURL() + `/search?q=${term}`;
        }
    }
}
</script>

<style scoped>
.BuscadorStandalone-MAIN{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: -40px;
    margin-bottom: 40px;
}

.BuscadorStandalone-search{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 2ch 0;
    background-color: white;
    border-radius: 7px;
    overflow: hidden;
    border: 1px solid #2b3d75;
    width: 100%;
}

.BuscadorStandalone-search input{
    height: 4ch;
    width: calc(100% - 6ch);
    border: none;
    padding-left: 1ch;
}

.BuscadorStandalone-search button{
    max-width: 5ch;
    max-height: 5ch;
    padding: 0;
    border: none;
    background-color: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 1ch;
    cursor: pointer;
    background-color: transparent;
    padding: 0.5ch;
}

.BuscadorStandalone-search button img{
    max-width: 100%;
    max-height: 100%;
}
</style>